import { UserType } from '../../../../../../api/types/user/user-type';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const editDocumentRequirementOperation = async (
  mappingUserRoleToDocTypeId: number,
  userRole: UserType,
  docTypeId: number,
  docName: string,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    await appApi.editUserRoleDocumentRequirement(
      mappingUserRoleToDocTypeId,
      userRole,
      docTypeId,
      docName,
    );

    // Refresh the global settings to show the updated document
    await globalSettingsStores.fetchSetting();
  } catch (error) {
    console.error('Error editing document requirement:', error);
    // You might want to show an error message to the user here
  } finally {
    setLoading(false);
  }
};
